export default "__VITE_PUBLIC_ASSET__a79789b1__"